<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import offline from '@/store/offline/index'
import axios from 'axios'

export default {
  mixins: [Laraform],
  mounted() {
    this.$forceUpdate()
  },
  created() {
    this.on('submit', response => {})
    this.on('fail', response => {})
    this.on('success', response => {
      console.log('Success: ', response)
      if (response.callback.params.action) {
        let action = response.callback.params.action
        this.$store.dispatch(action.method, action.params)
      }
      if (response.callback.params.notification) {
        this.setNotification(response.callback.params.notification)
        this.$router.push('/calls/active')
      }
      this.addCompletedCallForm(response.payload)
      this.fire(response.callback.event, { params: response.callback.params })
    })
    this.on('redirect', params => {
      this.clearPORequest()
      if (params.notification) {
        this.setNotification(params.notification)
      }
      //this.$router.push('/calls/active')
    })
    this.on('message', params => {
      this.setNotification(params.notification)
    })
    this.on('change', () => {
      this.updateLaraFormStore({
        path: this.getSelectedFormId,
        value: this.data
      })
    })
  },
  methods: {
    ...mapActions({
      addCompletedCallForm: 'calls/addCompletedCallForm'
    }),
    ...mapMutations({
      setNotification: 'root/SET_NOTIFICATION',
      updateLaraFormStore: 'calls/UPDATE_LARAFORM_STORE',
      clearPORequest: 'calls/CLEAR_PO_REQUEST'
    }),
    send() {
      let payload = {
        data: this.data,
        endpoint: this.endpoint
      }
      payload.data.model_id = this.activeCall.id

      return axios
        .post(payload.endpoint, payload.data, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => {
          this.fire('response', response)

          if (response.data.status) {
            this.fire(response.data.status, response)
          }
          offline.attemptToSyncForm(response, payload)
          return response
        })
        .catch(e => {
          this.$router.push('/calls/active')
          this.setNotification('Form was saved offline')
        })
    }
  },
  computed: {
    ...mapGetters({
      activeCall: 'calls/getActiveCall',
      user: 'root/user',
      getFormData: 'calls/getFormData',
      getSelectedFormId: 'calls/getSelectedFormId'
    })
  }
}
</script>
<style lang="scss">
@import 'bootstrap/scss/bootstrap.scss';
@import '@laraform/laraform/src/themes/default/scss/theme.scss';
</style>
